import React from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import UploadPhotoInput from './uploadPhotoInput';


const UploadPhoto = ({ name, className, children, maxWidth, ...props }) => (
  <Field
    name={name}
    component={UploadPhotoInput}
    className={className}
    maxWidth={maxWidth}
    {...props}
  >
    {children}
  </Field>
);
UploadPhoto.propTypes = {
  name: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired,
  className: PropTypes.string,
  maxWidth: PropTypes.number,
};
UploadPhoto.defaultProps = {
  className: '',
  children: null,
  maxWidth: undefined,
};


export default UploadPhoto;
